import type { DecoratedUnisonProjectTask } from '@witmetrics/utils';

export const classes = {
  card: 'mx-0 mb-0 w-full items-start rounded-none border-0 border-b border-black/[0.06] bg-transparent pl-[18px] pr-2 py-3 shadow-none transition-colors hover:border-black/[0.06] hover:bg-black/[0.03] dark:border-white/[0.08] dark:hover:border-white/[0.08] dark:hover:bg-white/[0.04]',
  highlighted:
    'border-l-2 border-l-brand-accent bg-brand-accent/[0.06] dark:bg-brand-accent/[0.12]',
  content: 'flex w-full items-start gap-3',
  textColumn: 'flex flex-col gap-0.5 grow min-w-0',
  profilePicture: 'cursor-default',
};

export function isHighlighted(
  { taskId }: DecoratedUnisonProjectTask,
  searchParams: URLSearchParams
) {
  if (!searchParams.get('highlightedTaskId')) return false;
  return taskId === parseInt(searchParams.get('highlightedTaskId')!);
}
